import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

//饭卡充值
const recharge = r =>
  require.ensure([], () => r(require("../recharge/recharge")), "recharge");
const rechargeHistory = r =>
  require.ensure(
    [],
    () => r(require("../recharge/rechargeHistory")),
    "rechargeHistory"
  );
// 零星缴费
const payAdd = r =>
  require.ensure([], () => r(require("../payment/add")), "payAdd");
const wxPay = r =>
  require.ensure([], () => r(require("../payment/pay")), "wxPay");
const payHistory = r =>
  require.ensure([], () => r(require("../payment/payHistory")), "payHistory");
const receipt = r =>
  require.ensure([], () => r(require("../payment/receipt")), "receipt");
const receiptPc = r =>
  require.ensure([], () => r(require("../payment/receiptPc")), "receiptPc");
const phoneList = r =>
  require.ensure([], () => r(require("../payment/phoneList")), "phoneList");
const phoneLogin = r =>
  require.ensure([], () => r(require("../payment/phoneLogin")), "phoneLogin");

// export default new Router({
const newRouter = new Router({
  mode: "history",
  routes: [
    {
      name: "home",
      path: "/home",
      component: resolve => require(["@/examples/home"], resolve),
      meta: {
        title: "首页"
      }
    },
    // {
    //   name: 'memberManage',
    //   path: '/member-manage',
    //   component: resolve => require(['@/examples/memberManage'], resolve),
    //   meta: {
    //     title: '成员管理'
    //   }
    // },
    // {
    //   name: 'departmentManage',
    //   path: '/department-manage',
    //   component: resolve => require(['@/examples/departmentManage'], resolve),
    //   meta: {
    //     title: '部门管理'
    //   }
    // },
    // {
    //   name: 'accredit',
    //   path: '/accredit',
    //   component: resolve => require(['@/examples/accredit'], resolve),
    //   meta: {
    //     title: '网页授权'
    //   }
    // },
    // {
    //   name: 'scanCodeLogin',
    //   path: '/scanCodeLogin',
    //   component: resolve => require(['@/examples/scanCodeLogin'], resolve),
    //   meta: {
    //     title: '扫一扫登录'
    //   }
    // },
    {
      name: "jssdkExploit",
      path: "/jssdkExploit",
      component: resolve => require(["@/examples/jssdkExploit"], resolve),
      meta: {
        title: "网页开发"
      }
    },
    //饭卡充值
    {
      name: "recharge",
      path: "/",
      component: recharge,
      meta: {
        title: "饭卡充值",
        keepAlive: true
      }
    },
    {
      name: "rechargeHistory",
      path: "/rechargeHistory",
      component: rechargeHistory,
      meta: {
        title: "充值记录",
        keepAlive: false
      }
    },
    //零星缴费
    {
      name: "payAdd",
      path: "/payAdd",
      component: payAdd,
      meta: {
        title: "零星缴费",
        keepAlive: true
      }
    },
    {
      name: "wxPay",
      path: "/wxPay",
      component: wxPay,
      meta: {
        title: "零星缴费",
        keepAlive: false
      }
    },
    {
      name: "payHistory",
      path: "/payHistory",
      component: payHistory,
      meta: {
        title: "开单记录",
        keepAlive: false
      }
    },
    {
      name: "receipt",
      path: "/receipt",
      component: receipt,
      meta: {
        title: "收款收据",
        keepAlive: false
      }
    },
    {
      name: "receiptPc",
      path: "/receiptPc",
      component: receiptPc,
      meta: {
        title: "收款收据",
        keepAlive: false
      }
    },
    {
      name: "phoneList",
      path: "/phoneList",
      component: phoneList,
      meta: {
        title: "开单列表",
        keepAlive: true
      }
    },
    {
      name: "phoneLogin",
      path: "/phoneLogin",
      component: phoneLogin,
      meta: {
        title: "手机验证登录",
        keepAlive: false
      }
    }
  ]
});

newRouter.beforeEach((route, redirect, next) => {
  document.title = route.meta.title || document.title;
  next();
});

export default newRouter;



// WEBPACK FOOTER //
// ./src/router/index.js